(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  const removeEngravingAddonCards = (root = document) => {
    const cards = root.querySelectorAll('.product-grid__item');

    cards.forEach((card) => {
      const cardText = (card.textContent || '').toLowerCase();
      const productLink = card.querySelector('a[href*="/products/"]');
      const productHref = (productLink?.getAttribute('href') || '').toLowerCase();

      const isEngravingAddonCard =
        cardText.includes('engraving upcharge') ||
        productHref.includes('/products/engraving');

      if (isEngravingAddonCard) {
        card.remove();
      }
    });
  };

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      removeEngravingAddonCards();

      const productGrid = document.querySelector('#ResultsList .product-grid');
      if (!productGrid) return;

      const observer = new MutationObserver(() => {
        removeEngravingAddonCards(productGrid);
      });

      observer.observe(productGrid, { childList: true, subtree: true });
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();
})();
